require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/fn/object/freeze.js
// module id = 799
// module chunks = 1